import { Field } from 'formik'
import { TextField } from 'formik-mui'
import * as React from 'react'

const FullWidthField = (props: any) => {
  const {
    errorMessage,
    fullWidth,
    Label,
    InputLabelProps,
    label,
    defaultValue,
    inputId,
    clearable,
    shrink,
    inputRef,
    ...restProps
  } = props
  const labelValue = typeof Label === 'string' ? Label : label

  // Ensure inputRef doesn't get passed to TextField
  const fieldProps = {
    ...restProps,
    component: TextField,
    fullWidth: fullWidth !== false,
    label: labelValue,
    InputLabelProps: { shrink: true, ...InputLabelProps },
  }

  return <Field {...fieldProps} />
} // Temporary override for data upload 03/09/21
export default FullWidthField
